import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as MergeIcon } from './icons/mergeBranch.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, AlmanacFileVcmChangedEvent } from './Types'
import Styles from './ActivityEvent.module.scss'

interface Props extends ActivityEventPosition {
  event: AlmanacFileVcmChangedEvent
}

export const AlmanacFileVcmChanged = ({ event, ...props }: Props) => {
  const { user, data } = event

  const toggledValue = data.new_value ? 'on' : 'off'

  return (
    <BaseActivityEvent
      {...props}
      icon={<MergeIcon className={Styles.mergeIcon} />}
      timestamp={event.timestamp}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> turned {toggledValue} version
          control mode
        </>
      }
    />
  )
}
